module.exports = __webpack_public_path__ + "static/img/FI.39c830b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries/FI.svg
// module id = pWsP
// module chunks = 1